import React from 'react'
import { useTheme } from 'styled-components'
import BsInfoCircle from '@meronex/icons/bs/BsInfoCircle'

import {
  OrderBill,
  Exclamation,
  PaymentWrapper
} from './styles'

import {
  useLanguage,
  useUtils,
  useConfig
} from '~components'
import { verifyDecimals, capitalize, generalUtilities } from '~ui'

export const OrderBillSection = (props) => {
  const {
    order,
    setOpenTaxModal,
    showOnlyTotals,
    isHideTotal,
    orderCompleted
  } = props

  const [, t] = useLanguage()
  const theme = useTheme()
  const [{ parsePrice, parseNumber }] = useUtils()
  const [{ configs }] = useConfig()
  const { walletName } = generalUtilities()
  const isPickup = order?.delivery_type === 2

  const extraValueAdjustment = order?.metafields?.find?.(meta => meta?.key === 'extra_value_adjustment_amount')

  const getIncludedTaxes = (isDeliveryFee) => {
    if (order?.taxes?.length === 0) {
      return order.tax_type === 1 ? order?.summary?.tax ?? 0 : 0
    } else {
      return order?.taxes.reduce((taxIncluded, tax) => {
        return taxIncluded + (((!isDeliveryFee && tax.type === 1 && tax.target === 'product') || (isDeliveryFee && tax.type === 1 && tax.target === 'delivery_fee')) ? tax.summary?.tax : 0)
      }, 0)
    }
  }

  const getIncludedTaxesDiscounts = () => {
    return order?.taxes?.filter(tax => (tax?.type === 1 && tax?.target === 'product'))?.reduce((carry, tax) => carry + (tax?.summary?.tax_after_discount ?? tax?.summary?.tax), 0)
  }

  const getOrderSubtotal = (products) => {
    let subTotal = 0
    for (const product of products) {
      if (!product.prdDelete) {
        let subOptionPrice = 0
        if (Array.isArray(product?.options)) {
          if (product.options?.length > 0) {
            for (const option of product.options) {
              for (const suboption of option.suboptions) {
                subOptionPrice += suboption.quantity * ((['left', 'right'].includes(suboption.position)) ? (suboption.half_price ?? suboption.price) : suboption.price)
              }
            }
          }
        }
        subTotal += product.quantity * (product.price + subOptionPrice)
      }
    }

    return parseFloat(subTotal.toFixed(2))
  }

  const getOrderFees = (products, percentage) => {
    let subTotal = 0
    for (const product of products) {
      if (!product.prdDelete) {
        let subOptionPrice = 0
        if (Array.isArray(product?.options)) {
          if (product.options?.length > 0) {
            for (const option of product.options) {
              for (const suboption of option.suboptions) {
                subOptionPrice += suboption.quantity * ((['left', 'right'].includes(suboption.position)) ? (suboption.half_price ?? suboption.price) : suboption.price)
              }
            }
          }
        }
        subTotal += product.quantity * (product.price + subOptionPrice)
      }
    }

    let feeperval = (percentage / 100) * subTotal
    feeperval = Math.round(feeperval, 2)

    return parseFloat(feeperval.toFixed(2))
  }

  const getOrderServiceFee = (order, products) => {
    let subTotal = 0
    for (const product of products) {
      let subOptionPrice = 0
      if (Array.isArray(product?.options)) {
        if (product.options?.length > 0) {
          for (const option of product.options) {
            for (const suboption of option.suboptions) {
              subOptionPrice += suboption.quantity * ((['left', 'right'].includes(suboption.position)) ? (suboption.half_price ?? suboption.price) : suboption.price)
            }
          }
        }
      }
      subTotal += product.quantity * (product.price + subOptionPrice)
    }
    let ordtypeServiceFee = 0
    if (order?.delivery_type === 1) {
      let found = 0
      if (order?.servicefeedatabus?.delfeefixed && order?.servicefeedatabus?.delfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.delfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.delfeeper && order?.servicefeedatabus?.delfeeper > 0 && order?.servicefeedatabus?.delminprc && order?.servicefeedatabus?.delminprc > 0 && order?.servicefeedatabus?.delmaxprc && order?.servicefeedatabus?.delmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.delfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.delmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.delmaxprc
          } else if (pervar <= order?.servicefeedatabus?.delminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.delminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.delfeefixed && order?.servicefeedatasuper?.delfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.delfeefixed
        } else {
          if (order?.servicefeedatasuper?.delfeeper && order?.servicefeedatasuper?.delfeeper > 0 && order?.servicefeedatasuper?.delminprc && order?.servicefeedatasuper?.delminprc > 0 && order?.servicefeedatasuper?.delmaxprc && order?.servicefeedatasuper?.delmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.delfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.delmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.delmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.delminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.delminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 2) {
      let found = 0
      if (order?.servicefeedatabus?.picfeefixed && order?.servicefeedatabus?.picfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.picfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.picfeeper && order?.servicefeedatabus?.picfeeper > 0 && order?.servicefeedatabus?.picminprc && order?.servicefeedatabus?.picminprc > 0 && order?.servicefeedatabus?.picmaxprc && order?.servicefeedatabus?.picmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.picfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.picmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.picmaxprc
          } else if (pervar <= order?.servicefeedatabus?.picminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.picminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.picfeefixed && order?.servicefeedatasuper?.picfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.picfeefixed
        } else {
          if (order?.servicefeedatasuper?.picfeeper && order?.servicefeedatasuper?.picfeeper > 0 && order?.servicefeedatasuper?.picminprc && order?.servicefeedatasuper?.picminprc > 0 && order?.servicefeedatasuper?.picmaxprc && order?.servicefeedatasuper?.picmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.picfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.picmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.picmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.picminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.picminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 3) {
      let found = 0
      if (order?.servicefeedatabus?.eatinfeefixed && order?.servicefeedatabus?.eatinfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.eatinfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.eatinfeeper && order?.servicefeedatabus?.eatinfeeper > 0 && order?.servicefeedatabus?.eatinminprc && order?.servicefeedatabus?.eatinminprc > 0 && order?.servicefeedatabus?.eatinmaxprc && order?.servicefeedatabus?.eatinmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.eatinfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.eatinmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.eatinmaxprc
          } else if (pervar <= order?.servicefeedatabus?.eatinminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.eatinminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.eatinfeefixed && order?.servicefeedatasuper?.eatinfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.eatinfeefixed
        } else {
          if (order?.servicefeedatasuper?.eatinfeeper && order?.servicefeedatasuper?.eatinfeeper > 0 && order?.servicefeedatasuper?.eatinminprc && order?.servicefeedatasuper?.eatinminprc > 0 && order?.servicefeedatasuper?.eatinmaxprc && order?.servicefeedatasuper?.eatinmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.eatinfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.eatinmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.eatinmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.eatinminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.eatinminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 4) {
      let found = 0
      if (order?.servicefeedatabus?.curbfeefixed && order?.servicefeedatabus?.curbfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.curbfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.curbfeeper && order?.servicefeedatabus?.curbfeeper > 0 && order?.servicefeedatabus?.curbminprc && order?.servicefeedatabus?.curbminprc > 0 && order?.servicefeedatabus?.curbmaxprc && order?.servicefeedatabus?.curbmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.curbfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.curbmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.curbmaxprc
          } else if (pervar <= order?.servicefeedatabus?.curbminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.curbminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.curbfeefixed && order?.servicefeedatasuper?.curbfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.curbfeefixed
        } else {
          if (order?.servicefeedatasuper?.curbfeeper && order?.servicefeedatasuper?.curbfeeper > 0 && order?.servicefeedatasuper?.curbminprc && order?.servicefeedatasuper?.curbminprc > 0 && order?.servicefeedatasuper?.curbmaxprc && order?.servicefeedatasuper?.curbmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.curbfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.curbmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.curbmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.curbminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.curbminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 5) {
      let found = 0
      if (order?.servicefeedatabus?.drivertfeefixed && order?.servicefeedatabus?.drivertfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.drivertfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.drivertfeeper && order?.servicefeedatabus?.drivertfeeper > 0 && order?.servicefeedatabus?.drivertminprc && order?.servicefeedatabus?.drivertminprc > 0 && order?.servicefeedatabus?.drivertmaxprc && order?.servicefeedatabus?.drivertmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.drivertfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.drivertmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.drivertmaxprc
          } else if (pervar <= order?.servicefeedatabus?.drivertminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.drivertminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.drivertfeefixed && order?.servicefeedatasuper?.drivertfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.drivertfeefixed
        } else {
          if (order?.servicefeedatasuper?.drivertfeeper && order?.servicefeedatasuper?.drivertfeeper > 0 && order?.servicefeedatasuper?.drivertminprc && order?.servicefeedatasuper?.drivertminprc > 0 && order?.servicefeedatasuper?.drivertmaxprc && order?.servicefeedatasuper?.drivertmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.drivertfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.drivertmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.drivertmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.drivertminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.drivertminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 7) {
      let found = 0
      if (order?.servicefeedatabus?.catdelfeefixed && order?.servicefeedatabus?.catdelfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.catdelfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.catdelfeeper && order?.servicefeedatabus?.catdelfeeper > 0 && order?.servicefeedatabus?.catdelminprc && order?.servicefeedatabus?.catdelminprc > 0 && order?.servicefeedatabus?.catdelmaxprc && order?.servicefeedatabus?.catdelmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.catdelfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.catdelmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.catdelmaxprc
          } else if (pervar <= order?.servicefeedatabus?.catdelminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.catdelminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.catdelfeefixed && order?.servicefeedatasuper?.catdelfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.catdelfeefixed
        } else {
          if (order?.servicefeedatasuper?.catdelfeeper && order?.servicefeedatasuper?.catdelfeeper > 0 && order?.servicefeedatasuper?.catdelminprc && order?.servicefeedatasuper?.catdelminprc > 0 && order?.servicefeedatasuper?.catdelmaxprc && order?.servicefeedatasuper?.catdelmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.catdelfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.catdelmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.catdelmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.catdelminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.catdelminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    if (order?.delivery_type === 8) {
      let found = 0
      if (order?.servicefeedatabus?.catpicfeefixed && order?.servicefeedatabus?.catpicfeefixed > 0) {
        ordtypeServiceFee = order?.servicefeedatabus?.catpicfeefixed
        found = 1
      } else {
        if (order?.servicefeedatabus?.catpicfeeper && order?.servicefeedatabus?.catpicfeeper > 0 && order?.servicefeedatabus?.catpicminprc && order?.servicefeedatabus?.catpicminprc > 0 && order?.servicefeedatabus?.catpicmaxprc && order?.servicefeedatabus?.catpicmaxprc > 0) {
          let pervar = (order?.servicefeedatabus?.catpicfeeper / 100) * subTotal
          pervar = Math.round(pervar, 2)
          if (pervar >= order?.servicefeedatabus?.catpicmaxprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.catpicmaxprc
          } else if (pervar <= order?.servicefeedatabus?.catpicminprc) {
            ordtypeServiceFee = order?.servicefeedatabus?.catpicminprc
          } else {
            ordtypeServiceFee = pervar
          }
          found = 1
        }
      }

      if (found === 0) {
        if (order?.servicefeedatasuper?.catpicfeefixed && order?.servicefeedatasuper?.catpicfeefixed > 0) {
          ordtypeServiceFee = order?.servicefeedatasuper?.catpicfeefixed
        } else {
          if (order?.servicefeedatasuper?.catpicfeeper && order?.servicefeedatasuper?.catpicfeeper > 0 && order?.servicefeedatasuper?.catpicminprc && order?.servicefeedatasuper?.catpicminprc > 0 && order?.servicefeedatasuper?.catpicmaxprc && order?.servicefeedatasuper?.catpicmaxprc > 0) {
            let pervar = (order?.servicefeedatasuper?.catpicfeeper / 100) * subTotal
            pervar = Math.round(pervar, 2)
            if (pervar >= order?.servicefeedatasuper?.catpicmaxprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.catpicmaxprc
            } else if (pervar <= order?.servicefeedatasuper?.catpicminprc) {
              ordtypeServiceFee = order?.servicefeedatasuper?.catpicminprc
            } else {
              ordtypeServiceFee = pervar
            }
          }
        }
      }
    }
    return parseFloat(ordtypeServiceFee).toFixed(2)
  }

  const getPreOrderTotals = (order) => {
    let totalVal = 0
    if (order?.prevProducts && order?.prevProducts.length > 0) {
      const products = order?.prevProducts[order?.prevProducts.length - 1]

      const subTotalVal = getOrderSubtotal(products)
      const ordtypeServiceFee = getOrderServiceFee(order, products)
      let feeperval = 0
      if (order?.fees?.length > 0) {
        for (const feeper of order?.fees) {
          if (feeper?.percentage > 0) {
            feeperval += getOrderFees(products, feeper?.percentage)
          }
        }
      }
      totalVal = parseFloat(subTotalVal) + parseFloat(ordtypeServiceFee) + parseFloat(feeperval) + parseFloat(order?.olddelzoneprice ?? order?.summary?.delivery_price) + parseFloat(order?.resturant_tips ?? 0) + parseFloat(order?.resturant_commission ?? 0)
      totalVal = Math.round(totalVal, 2)
    } else {
      const products = order?.products
      const subTotalPreVal = getOrderSubtotal(products)
      const ordtypePreServiceFee = getOrderServiceFee(order, products)
      let feepervalPre = 0
      if (order?.fees?.length > 0) {
        for (const feeper of order?.fees) {
          if (feeper?.percentage > 0) {
            feepervalPre += getOrderFees(products, feeper?.percentage)
          }
        }
      }
      totalVal = parseFloat(subTotalPreVal) + parseFloat(ordtypePreServiceFee) + parseFloat(feepervalPre) + parseFloat(order?.olddelzoneprice ?? order?.summary?.delivery_price) + parseFloat(order?.resturant_tips ?? 0) + parseFloat(order?.resturant_commission ?? 0)
      totalVal = Math.round(totalVal, 2)
    }
    return parseFloat(totalVal.toFixed(2))
  }

  return (
    <OrderBill orderCompleted={orderCompleted}>
      <table>
        <tbody>
          <tr className='subtotal'>
            <td>{t('SUBTOTAL', theme?.defaultLanguages?.SUBTOTAL || 'Subtotal')}</td>
            <td>
              { order?.editorder && getOrderSubtotal(order?.prevProducts[order?.prevProducts.length - 1]) !== (order?.summary?.subtotal ?? order?.subtotal) && (
              <span className='mrp-price-product'>{parsePrice(getOrderSubtotal(order?.prevProducts[order?.prevProducts.length - 1]))}</span>
              )}
              {parsePrice(((order?.summary?.subtotal ?? order?.subtotal) + getIncludedTaxes()))}
            </td>
          </tr>
          {!showOnlyTotals && (
            <>
              {(order?.summary?.discount > 0 ?? order?.discount > 0) && order?.offers?.length === 0 && (
                <tr>
                  {order?.offer_type === 1
                    ? (
                      <td>
                        {t('DISCOUNT', theme?.defaultLanguages?.DISCOUNT || 'Discount')}{' '}
                        <span>{`(${verifyDecimals(order?.offer_rate, parsePrice)}%)`}</span>
                      </td>
                      )
                    : (
                      <td>{t('DISCOUNT', theme?.defaultLanguages?.DISCOUNT || 'Discount')}</td>
                      )}
                  <td>- {parsePrice(order?.summary?.discount ?? order?.discount)}</td>
                </tr>
              )}
              {
                order?.offers?.length > 0 && order?.offers?.filter(offer => offer?.target === 1)?.map(offer => (
                  <tr key={offer.id}>
                    <td>
                      {t(offer.name?.toUpperCase()?.replace(/ /g, '_'), offer.name)}
                      {offer.rate_type === 1 && (
                        <span>{`(${verifyDecimals(offer?.rate, parsePrice)}%)`}</span>
                      )}
                      {setOpenTaxModal && (
                        <Exclamation onClick={() => setOpenTaxModal({ open: true, data: offer, type: 'offer_target_1' })}>
                          <BsInfoCircle size='20' color={theme.colors.primary} />
                        </Exclamation>
                      )}
                    </td>
                    <td>
                      - {parsePrice(offer?.summary?.discount)}
                    </td>
                  </tr>
                ))
              }
              {order?.offers?.filter(offer => offer?.target === 1)?.length > 0 &&
                order?.summary?.subtotal_with_discount > 0 &&
                order?.summary?.discount > 0 &&
                order?.summary?.total >= 0 && (
                  <tr>
                    <td>{t('SUBTOTAL_WITH_DISCOUNT', 'Subtotal with discount')}</td>
                    {order?.tax_type === 1
                      ? (
                        <td>{parsePrice((order?.summary?.subtotal_with_discount + getIncludedTaxesDiscounts() ?? 0))}</td>
                        )
                      : (
                        <td>{parsePrice(order?.summary?.subtotal_with_discount ?? 0)}</td>
                        )}
                  </tr>
              )}
              {
                order?.taxes?.length === 0 && order?.tax_type === 2 && (
                  <tr>
                    <td>
                      {t('TAX', 'Tax')}
                      <span>{`(${verifyDecimals(order?.tax, parseNumber)}%)`}</span>
                    </td>
                    <td>{parsePrice(order?.summary?.tax ?? 0)}</td>
                  </tr>
                )
              }
              {
                order?.fees?.length === 0 && (
                  <tr>
                    <td>
                      {t('SERVICE_FEE', 'Service fee')}
                      <span>{`(${verifyDecimals(order?.service_fee, parseNumber)}%)`}</span>
                    </td>
                    <td>{parsePrice(order?.summary?.service_fee ?? 0)}</td>
                  </tr>
                )
              }
              {
                order?.taxes?.length > 0 && order?.taxes?.filter(tax => tax?.type === 2 && tax?.rate !== 0 && tax?.target === 'product').map(tax => (
                  <tr key={tax?.id}>
                    <td>
                      {t(tax?.name?.toUpperCase()?.replace(/ /g, '_'), tax?.name) || t('INHERIT_FROM_BUSINESS', 'Inherit from business')}
                      <span>{`(${verifyDecimals(tax?.rate, parseNumber)}%)`}</span>
                      {setOpenTaxModal && (
                        <Exclamation onClick={() => setOpenTaxModal({ open: true, data: tax, type: 'tax' })}>
                          <BsInfoCircle size='20' color={theme.colors.primary} />
                        </Exclamation>
                      )}
                    </td>
                    <td>{parsePrice(tax?.summary?.tax_after_discount ?? tax?.summary?.tax ?? 0)}</td>
                  </tr>
                ))
              }
              {
                order?.fees?.length > 0 && order?.fees?.filter(fee => (!(fee.fixed === 0 && fee.percentage === 0) || (fee?.fee_id === null && fee?.type === 'product' && fee?.percentage > 0))).map((fee, i) => (
                  <tr key={fee.id ?? i}>
                    <td>
                      {t(fee?.name?.toUpperCase()?.replace(/ /g, '_'), fee?.name) || t('INHERIT_FROM_BUSINESS', 'Inherit from business')}
                      {!(fee.fixed === 0 && fee.percentage === 0) && (
                        <>
                          ({fee?.fixed > 0 && `${parsePrice(fee?.fixed)}${fee.percentage > 0 ? ' + ' : ''}`}{fee.percentage > 0 && `${fee.percentage}%`})
                          {setOpenTaxModal && (
                            <Exclamation onClick={() => setOpenTaxModal({ open: true, data: fee, type: 'fee' })}>
                              <BsInfoCircle size='20' color={theme.colors.primary} />
                            </Exclamation>
                          )}
                        </>
                      )}
                    </td>
                    <td>{parsePrice(fee?.summary?.fixed + (fee?.summary?.percentage_after_discount ?? fee?.summary?.percentage) ?? 0)}</td>
                  </tr>
                ))
              }
              {
                order?.offers?.length > 0 && order?.offers?.filter(offer => offer?.target === 3)?.map(offer => (
                  <tr key={offer.id}>
                    <td>
                      {t(offer?.name?.toUpperCase()?.replace(/ /g, '_'), offer?.name)}
                      {offer.rate_type === 1 && (
                        <span>{`(${verifyDecimals(offer?.rate, parsePrice)}%)`}</span>
                      )}
                      {setOpenTaxModal && (
                        <Exclamation onClick={() => setOpenTaxModal({ open: true, data: offer, type: 'offer_target_3' })}>
                          <BsInfoCircle size='20' color={theme.colors.primary} />
                        </Exclamation>
                      )}
                    </td>
                    <td>
                      - {parsePrice(offer?.summary?.discount)}
                    </td>
                  </tr>
                ))
              }
              {typeof order?.summary?.delivery_price === 'number' && !isPickup && order?.summary?.delivery_price > 0 && (
                <tr>
                  <td>{t('DELIVERY_FEE', theme?.defaultLanguages?.DELIVERY_FEE || 'Delivery Fee')}</td>
                  <td>{parsePrice(order?.summary?.delivery_price + getIncludedTaxes(true))}</td>
                </tr>
              )}
              {order?.extra_value_checkprice && order?.extra_value_checkprice > 0 && (
                <tr>
                  <td>{t('EXTRA_VALUE_CHECKPRICE', 'Extra value checkprice')}</td>
                  <td>{parsePrice(order?.extra_value_checkprice)}</td>
                </tr>
              )}
              {
                order?.taxes?.length > 0 && order?.taxes?.filter(tax => tax?.type === 2 && tax?.rate !== 0 && tax?.target === 'delivery_fee').map(tax => (
                  <tr key={tax?.id}>
                    <td>
                      {tax?.name ? t(tax?.name?.toUpperCase()?.replace(/ /g, '_'), capitalize(tax?.name?.replace(/_/g, ' ')?.toLowerCase())) : t('INHERIT_FROM_BUSINESS', 'Inherit from business')}
                      <span>{`(${verifyDecimals(tax?.rate, parseNumber)}%)`}</span>
                      {setOpenTaxModal && (
                        <Exclamation onClick={() => setOpenTaxModal({ open: true, data: tax, type: 'tax' })}>
                          <BsInfoCircle size='20' color={theme.colors.primary} />
                        </Exclamation>
                      )}
                    </td>
                    <td>{parsePrice(tax?.summary?.tax_after_discount ?? tax?.summary?.tax ?? 0)}</td>
                  </tr>
                ))
              }
              {
                order?.offers?.length > 0 && order?.offers?.filter(offer => offer?.target === 2)?.map(offer => (
                  <tr key={offer.id}>
                    <td>
                      {t(offer.name?.toUpperCase()?.replace(/ /g, '_'), offer.name)}
                      {offer.rate_type === 1 && (
                        <span>{`(${verifyDecimals(offer?.rate, parsePrice)}%)`}</span>
                      )}
                      {setOpenTaxModal && (
                        <Exclamation onClick={() => setOpenTaxModal({ open: true, data: offer, type: 'offer_target_2' })}>
                          <BsInfoCircle size='20' color={theme.colors.primary} />
                        </Exclamation>
                      )}
                    </td>
                    <td>
                      - {parsePrice(offer?.summary?.discount)}
                    </td>
                  </tr>
                ))
              }
              {(order?.summary?.driver_tip > 0 || order?.driver_tip > 0) && (
                <tr>
                  <td>
                    {t('DRIVER_TIP', theme?.defaultLanguages?.DRIVER_TIP || 'Driver tip')}{' '}
                    {(order?.summary?.driver_tip > 0 || order?.driver_tip > 0) &&
                      parseInt(configs?.driver_tip_type?.value, 10) === 2 &&
                      !parseInt(configs?.driver_tip_use_custom?.value, 10) &&
                      (
                        <span>{`(${verifyDecimals(order?.driver_tip, parseNumber)}%)`}</span>
                      )}
                  </td>
                  <td>{parsePrice(order?.summary?.driver_tip ?? order?.totalDriverTip)}</td>
                </tr>
              )}
              {extraValueAdjustment && !!parseFloat(extraValueAdjustment?.value) && (
                <tr>
                  <td>
                    {t(extraValueAdjustment?.key?.toUpperCase(), extraValueAdjustment?.key)}{' '}
                  </td>
                  <td>{parseFloat(extraValueAdjustment?.value) > 0 ? parsePrice(parseFloat(extraValueAdjustment?.value)) : `- ${parsePrice(parseFloat(extraValueAdjustment?.value) * -1)}`}</td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
      {!isHideTotal && (
        <table className='total'>
          <tbody>
            <tr>
              <td>{t('TOTAL', theme?.defaultLanguages?.TOTAL || 'Total')}</td>
              <td>
                { order?.editorder && (
                  <span className='mrp-price-product'>{parsePrice(getPreOrderTotals(order))}</span>
                )}
                {parsePrice(order?.summary?.total ?? order?.total)}</td>
            </tr>
          </tbody>
        </table>
      )}
      <table>
        <tbody>
          {
            order?.chcreditdata?.length > 0 && order?.chcreditdata?.filter(chcre => chcre?.cus_type === 1)?.map(chcre => (
              <tr key={chcre.cus_type}>
                <td>
                  {chcre.type === '2' ? t('EXTRA_CHARGED', 'Extra Charged') : t('Credit', 'Credit')}
                  <br />
                  <span>{t('FOR', 'For')} {chcre.reason}</span>
                </td>
                <td>
                  {parsePrice(chcre?.amount)}
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
      {order?.payment_events?.length > 0 && !showOnlyTotals && (
        <>
          <PaymentWrapper>
            <div className='payments-list'>
              {order?.payment_events?.map(event => event.amount > 0 && (
                <div
                  className='payment-item'
                  key={event.id}
                >
                  <div className='paymethod'>
                    <div className='paymethod-row'>
                      <span>
                        {event?.wallet_event
                          ? walletName[event?.wallet_event?.wallet?.type]?.description
                          : t(event?.paymethod?.gateway?.toUpperCase() ?? 'PAYMENT', capitalize(event?.paymethod?.gateway?.replace(/_/g, ' ')?.toLowerCase() || 'Payment'))}
                      </span>
                      <span>
                        -{parsePrice(event.amount, { isTruncable: true })}
                      </span>
                    </div>
                    {event?.data?.charge_id && (
                      <span>
                        {`${t('CODE', 'Code')}: ${event?.data?.charge_id}`}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </PaymentWrapper>
        </>
      )}
    </OrderBill>
  )
}
